export const ProductIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="poc-evo-operators 1" clipPath="url(#clip0_35084_250850)">
            <g id="Clip path group">
                <mask
                    id="mask0_35084_250850"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                >
                    <g id="clip0_15816_58847">
                        <path id="Vector" d="M24 0H0V24H24V0Z" fill="white" />
                    </g>
                </mask>
                <g mask="url(#mask0_35084_250850)">
                    <g id="Group">
                        <path
                            id="Vector_2"
                            d="M16.8 0H7.2C4.67976 0 3.41965 0 2.45705 0.490471C1.61032 0.921901 0.921901 1.61032 0.490471 2.45705C0 3.41965 0 4.67976 0 7.2V16.8C0 19.3202 0 20.5804 0.490471 21.543C0.921901 22.3898 1.61032 23.078 2.45705 23.5095C3.41965 24 4.67976 24 7.2 24H16.8C19.3202 24 20.5804 24 21.543 23.5095C22.3898 23.078 23.078 22.3898 23.5095 21.543C24 20.5804 24 19.3202 24 16.8V7.2C24 4.67976 24 3.41965 23.5095 2.45705C23.078 1.61032 22.3898 0.921901 21.543 0.490471C20.5804 0 19.3202 0 16.8 0Z"
                            fill="url(#paint0_linear_35084_250850)"
                        />
                        <path
                            id="Vector_3"
                            d="M20.0905 16.4314C20.09 16.5462 20.0442 16.6561 19.9631 16.7372C19.8821 16.8183 19.7721 16.8641 19.6574 16.8645H14.0887C14.0429 16.862 13.9995 16.8427 13.9671 16.8102C13.9346 16.7777 13.9152 16.7344 13.9127 16.6885V16.5124C13.9119 15.8705 13.7832 15.2351 13.5339 14.6435C13.2847 14.0519 12.92 13.516 12.4611 13.067C12.4396 13.045 12.423 13.0187 12.4124 12.9899C12.4018 12.9611 12.3973 12.9303 12.3994 12.8997C12.4015 12.869 12.41 12.8391 12.4244 12.812C12.4389 12.7848 12.4589 12.761 12.4831 12.7422C13.1896 12.2735 14.0191 12.0247 14.8669 12.0274H15.712C16.8739 12.0396 17.9843 12.5083 18.8036 13.3323C19.6227 14.1563 20.085 15.2695 20.0905 16.4314Z"
                            fill="#79E22D"
                        />
                        <path
                            id="Vector_4"
                            d="M15.2798 11.378C16.6678 11.378 17.793 10.2528 17.793 8.86477C17.793 7.47676 16.6678 6.35156 15.2798 6.35156C13.8918 6.35156 12.7666 7.47676 12.7666 8.86477C12.7666 10.2528 13.8918 11.378 15.2798 11.378Z"
                            fill="#49B900"
                        />
                        <path
                            id="Vector_5"
                            d="M13.2649 16.863H4.09937C4.04201 16.8627 3.98706 16.8398 3.9465 16.7993C3.90594 16.7587 3.88305 16.7038 3.88281 16.6464C3.88422 15.4342 4.36638 14.2721 5.22353 13.4149C6.08068 12.5578 7.24283 12.0756 8.45502 12.0742H8.88812C10.1003 12.0756 11.2624 12.5578 12.1196 13.4149C12.9767 14.2721 13.4589 15.4342 13.4603 16.6464C13.4672 16.6744 13.4672 16.7036 13.4601 16.7315C13.4531 16.7594 13.4394 16.7852 13.4201 16.8066C13.4008 16.828 13.3766 16.8443 13.3495 16.8541C13.3225 16.8639 13.2934 16.867 13.2649 16.863Z"
                            fill="#49B900"
                        />
                        <path
                            id="Vector_6"
                            d="M8.69289 11.378C10.0809 11.378 11.2061 10.2528 11.2061 8.86477C11.2061 7.47676 10.0809 6.35156 8.69289 6.35156C7.30488 6.35156 6.17969 7.47676 6.17969 8.86477C6.17969 10.2528 7.30488 11.378 8.69289 11.378Z"
                            fill="#0E6C00"
                        />
                    </g>
                </g>
            </g>
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_35084_250850"
                x1="0.893438"
                y1="-0.77672"
                x2="23.1066"
                y2="24.7767"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FAFAFA" />
                <stop offset="1" stopColor="#E1E1E1" />
            </linearGradient>
            <clipPath id="clip0_35084_250850">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
